import React, { Component } from 'react';
import axios from 'axios';
import ForminputEmail from '../forminput/forminput_email.js';


export default class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: 1,
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp"
        };
        this.setFormValue = this.setFormValue.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
    }


    setFormValue(label, value) {
        // Update state
        this.setState({
            [label]: value
        });
    }


    async submitRequest() {
        this.props.setLoading();
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/resetuserpassword", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${this.props.token}`
                },
                body: JSON.stringify({
                    email: this.state.email
                }),
            });
            // Handle response
            response = await response.json();
            var data = response.value;
            //Proceed based on status
            if (data) {
                this.setState({
                    page: 2
                })
                this.props.unsetLoading();
            } else {
                // Track error
                var name = "";
                var message = "Could not reset your email. Please try again.";
                this.props.setError(name, message);
                this.props.unsetLoading();
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not reset your email. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "PasswordReset_submitRequest");
            this.props.unsetLoading();
        }
    }


    render() {

        return (
            <div className="content-container login-container">
                <img src={this.state.background_url} alt={""} className={"login__background"} />
                <div className="login__background login__background--overlay"></div>
                <form
                    className="login-wrapper"
                    onSubmit={e => {
                        e.preventDefault();      // prevent full-page reload
                        if (this.state.page === 1) {
                            this.submitRequest();  // only submit on page 1
                        }
                    }}
                >

                    {this.state.page === 1 &&
                        <div className="login">
                            <div className="login__element login__title text-subtitle">
                                Reset password
                            </div>
                            <div className="login__element form__content__element form__content__input">
                                <ForminputEmail
                                    name={"email"}
                                    label={"Email"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"Your email address"}
                                />
                            </div>
                            {this.state.loginError && this.state.loginError != "" &&
                                <div className="login__element form__content__element text-color-primary">
                                    {this.state.loginError}
                                </div>
                            }
                            <div className="login__element form__content__element form__content__buttonbox">
                                <button
                                    type="submit"
                                    className="form__content__buttonbox__button button button-primary"
                                >
                                    Reset password
                                </button>
                            </div>
                        </div>
                    }

                    {this.state.page === 2 &&
                        <div className="login">
                            <div className="login__element login__title text-subtitle">
                                Reset password
                            </div>
                            <div className="login__element form__content__element">
                                Password successfully reset. You will receive an email with instructions on how to reset your password.
                            </div>
                        </div>
                    }

                </form>
            </div>
        )
    }
}
